if (!customElements.get('gastrotest-stats')) {
  customElements.define('gastrotest-stats', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.counters = [...this.querySelectorAll('.gt-stat strong')].map(element => {
        const value = element.textContent.trim();
        return {
          element,
          target: parseInt(value, 10),
          suffix: value.replace(/^\d+/, '')
        };
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

      this.counters.forEach(({ element, target, suffix }) => {
        element.setAttribute('aria-label', `${target}${suffix}`);
        element.textContent = `0${suffix}`;
      });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        let start;
        const tick = time => {
          start ??= time;
          const progress = Math.min((time - start) / 1400, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.counters.forEach(({ element, target, suffix }) => {
            element.textContent = `${Math.round(target * eased)}${suffix}`;
          });
          if (progress < 1) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.counters?.forEach(({ element, target, suffix }) => {
        element.textContent = `${target}${suffix}`;
      });
    }
  });
}
